import type {
  AddUserToWhitelistReply,
  AddUserToWhitelistRequest,
  CheckUserInWhitelistReply,
  CheckUserInWhitelistRequest,
  ListWhitelistReply,
  ListWhitelistRequest,
  RemoveUserFromWhitelistReply,
  RemoveUserFromWhitelistRequest,
} from '@/types';
import api from './api';

export const whitelistApi = {
  // 添加用户到权限白名单
  addUserToWhitelist: async (
    data: AddUserToWhitelistRequest,
  ): Promise<AddUserToWhitelistReply> => {
    return api.post('/api/v1/whitelist/users', data);
  },

  // 检查用户是否在权限白名单中
  // 注意：protobuf 定义中没有 HTTP 注解，可能需要通过 gRPC 调用
  // 这里暂时保留，如果后端提供了 HTTP 端点可以更新
  checkUserInWhitelist: async (
    _data: CheckUserInWhitelistRequest,
  ): Promise<CheckUserInWhitelistReply> => {
    // 如果后端提供了 HTTP 端点，可以在这里实现
    // 目前 protobuf 中没有 HTTP 注解，可能需要通过 gRPC 调用
    throw new Error('CheckUserInWhitelist endpoint not implemented via HTTP');
  },

  // 列表查询权限白名单
  listWhitelist: async (
    data: ListWhitelistRequest,
  ): Promise<ListWhitelistReply> => {
    return api.post('/api/v1/whitelist/list', data);
  },

  // 移除用户从权限白名单
  removeUserFromWhitelist: async (
    data: RemoveUserFromWhitelistRequest,
  ): Promise<RemoveUserFromWhitelistReply> => {
    return api.post('/api/v1/whitelist/users/remove', data);
  },
};
